/**
 * Generates a filename for a customer invoice based on its type and reference.
 * @function
 * @param {Object} customerInvoice - The customer invoice object.
 * @param {string} t - The translation function.
 * @returns {string} The filename for the customer invoice.
 */
export const invoicesFileName = (customerInvoice, t) =>
  `Facture ${t(`customerinvoices.tags.${customerInvoice?.type}`)} ${
    customerInvoice?.reference
  } - ${customerInvoice?.customer?.first_name} ${
    customerInvoice?.customer?.last_name
  }`;
